"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cantagallo": {
    "23a58e34": [{
      "hkey": "7c169e91",
      "slug": "cantagallo",
      "name": "Cantagallo",
      "primary": true,
      "skipSearch": false
    }],
    "gricigliana": [{
      "hkey": "7c169e91",
      "slug": "cantagallo",
      "name": "Cantagallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "47740352": [{
      "hkey": "7c169e91",
      "slug": "cantagallo",
      "name": "Cantagallo",
      "primary": true,
      "skipSearch": false
    }],
    "la-rocca-di-cerbaia": [{
      "hkey": "7c169e91",
      "slug": "cantagallo",
      "name": "Cantagallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;